
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.357 11.357"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_46010","data-name":"Group 46010","transform":"translate(-.5 -.5)"}},[_c('g',{attrs:{"id":"Group_46013","data-name":"Group 46013"}},[_c('rect',{attrs:{"id":"Rectangle_15668","data-name":"Rectangle 15668","width":"11.357","height":"11.357","transform":"translate(.5 .5)","fill":"none"}}),_c('path',{attrs:{"id":"Path_33786","data-name":"Path 33786","d":"M5.4 9.929a1.365 1.365 0 01-1.93 0l-2.1-2.1A1.367 1.367 0 013.3 5.895l1.138 1.134 4.6-4.6a1.368 1.368 0 011.937 1.933z","fill":"#5c8df5"}})])])])
          )
        }
      }
    